import React, { useState } from 'react';

const AdminLogin = ({ API_BASE_URL, onAdminLoginSuccess }) => {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleLogin = async () => {
        if (!password.trim()) { setError('비밀번호를 입력해주세요.'); return; }
        setError('');
        try {
            setLoading(true);
            const res = await fetch(`${API_BASE_URL}/api/auth/admin-login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password }),
            });
            const data = await res.json();
            if (data.success) {
                localStorage.setItem('admin_token', data.token);
                onAdminLoginSuccess && onAdminLoginSuccess(data);
            } else {
                setError(data.message || '로그인 실패');
            }
        } catch (e) {
            setError('서버 오류가 발생했습니다.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={S.page}>
            {/* Decorative blobs */}
            <div style={{ ...S.blob, top: '-40px', left: '-40px', background: 'rgba(96,165,250,0.3)' }} />
            <div style={{ ...S.blob, top: '-40px', right: '-40px', background: 'rgba(167,139,250,0.3)' }} />
            <div style={{ ...S.blob, bottom: '-40px', left: '40%', background: 'rgba(244,114,182,0.3)' }} />

            <div style={S.card}>
                <h1 style={S.title}>관리자 페이지</h1>

                {error && <div style={S.errorBox}>{error}</div>}

                <input
                    type="password"
                    autoFocus
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') handleLogin(); }}
                    placeholder="비밀번호를 입력하세요"
                    style={S.input}
                    disabled={loading}
                />

                <button onClick={handleLogin} disabled={loading} style={S.btn}>
                    {loading ? '로그인 중...' : '로그인'}
                </button>
            </div>

            {loading && <div style={S.overlay}><div style={S.spinner} /></div>}
        </div>
    );
};

const S = {
    page: {
        minHeight: '100vh', width: '100vw',
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        background: 'linear-gradient(135deg, #eff6ff 0%, #eef2ff 50%, #faf5ff 100%)',
        position: 'relative', overflow: 'hidden',
        fontFamily: "'Pretendard Variable', -apple-system, sans-serif",
    },
    blob: {
        position: 'absolute', width: '280px', height: '280px', borderRadius: '50%',
        filter: 'blur(60px)', zIndex: 0,
    },
    card: {
        position: 'relative', zIndex: 1, width: '100%', maxWidth: '420px', padding: '32px',
        background: 'rgba(255,255,255,0.8)', backdropFilter: 'blur(16px)',
        borderRadius: '16px', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.15)',
        display: 'flex', flexDirection: 'column', gap: '16px',
    },
    title: {
        fontSize: '28px', fontWeight: '700', textAlign: 'center', color: '#1f2937',
    },
    input: {
        width: '100%', padding: '14px', border: '1px solid #e5e7eb', borderRadius: '10px',
        fontSize: '16px', outline: 'none', boxSizing: 'border-box',
    },
    btn: {
        width: '100%', padding: '14px', border: 'none', borderRadius: '10px',
        background: '#18181b', color: '#fff', fontSize: '16px', fontWeight: '600',
        cursor: 'pointer',
    },
    errorBox: {
        padding: '10px', borderRadius: '8px', background: '#fef2f2',
        color: '#dc2626', border: '1px solid #fecaca', fontSize: '14px', textAlign: 'center',
    },
    overlay: {
        position: 'fixed', inset: 0, background: 'rgba(255,255,255,0.6)', zIndex: 50,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
    },
    spinner: {
        width: '36px', height: '36px', border: '3px solid #e5e7eb',
        borderTopColor: '#18181b', borderRadius: '50%', animation: 'spin 0.8s linear infinite',
    },
};

export default AdminLogin;
